import { ApiConfig } from '@beautybox/core/api';
import { removeSubdomain } from '@beautybox/core/utils/subdomains';
const isAutoResolveBaseUrl: boolean = import.meta.env.VITE_BASE_URL_AUTO
    ? import.meta.env.VITE_BASE_URL_AUTO === 'true'
    : true;
const BASE_URL = isAutoResolveBaseUrl ? removeSubdomain() : import.meta.env.VITE_BASE_URL;

export const config: ApiConfig = {
    module: 'crm',
    BASE_URL,
    token: localStorage.getItem('access_token') ?? undefined,
};

export default config;
